import { ITextFields } from "./components/Tables";

export const ListaEvidencijaResourcesEN: ListaEvidencijaResourcesBSInterface = {
  title: "Evidence",
  listaTacakaEvidencije: "View evidence by points",
  listaEvidencija: "View evidence",
  branchButton: "Select branch",
  errorLoading:
    "An error occurred during loading. Please contact the administrator.",
  next: "Forward",
  back: "Back",
  from: "From date: ",
  to: "To date: ",
  description: "Select a branch and date range to view evidence records",
  selectDateRange: "Select Date Range",
  loadingBranches: "Loading branches...",
  loadingEvidenceRecords: "Loading evidence records...",
  loadingEvidenceList: "Loading evidence list...",
  clickToViewDetails: "Click to view details",
  sanEvdsList: {
    found: "Evidence found",
    notFound: "Evidence not found",
    download: "Download PDF",
    button: "View sanitary evidence",
  },
  branch: {
    label: "Branch",
    placeholder: "Select branch",
    notFound: "No branch found",
  },
  evidencije: {
    title: "Completed evidence for selected period:",
    pojedinacneDownload: "Individual evidence PDF",
    zbirniDownload: "Collective evidence PDF",
    edit: "Edit",
  },
  pdf: {
    right: {
      title: "Selected period: ",
      from: "From: ",
      to: "To: ",
    },
    center: {
      title: "Evidence:",
    },
  },
  poljaEvidencije: {
    CIPP_V1: "Cleaning and washing premises",
    CIPO_V1: "Cleaning and washing equipment",
    Dezinfekcija_V1: "Disinfection",
    Dezinsekcija_V1: "Pest control",
    Deratizacija_V1: "Rodent control",
    Dezinsekcija_Kontrola_V1: "Pest control Control",
    Dezinskecija_Korekcija_V1: "Pest control Correction",
    Deratizacija_Kontrole_V1: "Rodent control Control",
    Deratizacija_Korekcije_V1: "Rodent control Correction",
    DezSr_V1: "Disinfection products",
    Dobavljac_V1: "Suppliers",
    Dostava_V1: "Delivery",
    EduZap_V1: "Employee education",
    Mol_V1: "Painting work",
    Oprema_V1: "Equipment",
    Otpad_V1: "Waste",
    PrijemRobe_V1: "Goods receipt",
    San_V1: "Sanitary inspection",
    Temperatura_V1: "Temperature lists",
    TemperaturaOgranicena_V1: "Temperature lists - limited",
    TemperaturaOgranicenaKKT_V1: "Temperature lists - limited - KKT",
    TemperaturaKKTProizvodiEvd_V1: "Temperature lists - products - KKT",
  },
  pdfListaEvidencija: {
    ispunjeno: "Fulfilled",
    ispravnaPosiljka: "Correct shipment",
    da: "Yes",
    ne: "No",
    proizvod: "Product",
    brojRacuna: "Invoice/dispatch note number",
    otpadKorektivnaMjera: "Adequately collected waste",
    tackaPrimjene: "Evidence point",
    donjaGranicaHeader: "Lower limit",
    gornjaGranicaHeader: "Upper limit",
    rasponHeader: "Range",
    odabraniPeriod: "Selected period",
    evidencija: "Evidence",
    period: "Selected period: ",
    datum: "Date and time",
    imeIPrezime: "First and last name",
    imePrezime: "First and last name",
    potpis: "Signature",
    naziv: "Name",
    tipEvidencije: "Evidence type",
    slikaDeklaracije: "Declaration Image",
    opisKontrole: "Control Description",
    stanjeKontrole: "Rodent infestation",
    opisKorekcije: "Correction Description",
    stanjeKorekcije: "Correction Status",
    primjena: "Application",
    upustvoZaUpotrebu: "Instructions for use",
    opis: "Description",
    vrsta: "Type",
    slika: "Image",
    address: "Address",
    phoneNumber: "Phone",
    idTax: "ID number",
    pdvTax: "VAT number",
    productType: "Product type",
    posiljalac: "Sender",
    potpisPosiljalac: "Sender signature",
    primalac: "Recipient",
    potpisPrimalac: "Recipient signature",
    dokument: "Document",
    primjedba: "Comment/Note",
    korektivnaMjera: "Corrective measure",
    temperatura: "Temperature",
    datumObuke: "Training date",
    mjestoObuke: "Training location",
    tipObuke: "Training type",
    izvrsilacObuke: "Training instructor",
    tema: "Topic",
    cilj: "Goal",
    verifikacijaEfikasnosti: "Efficiency verification",
    radnoMjesto: "Workplace",
    verifikacijaPrisustvaPotpis: "Attendance verification - signature",
    verifikacijaEdukatoraPotpis: "Educator verification - signature",
    izvrsioc: "Performed by",
    potpisIzvrsioca: "Performer signature",
    uposlenik: "Employee",
    vaziOd: "Valid from",
    vaziDo: "Valid to",
    tip: "Type",
    vrstaOtpada: "Waste type",
    otpadPredao: "Waste delivered by",
    otpadPrimio: "Waste received by",
    kolicina: "Quantity / unit of measure",
    primaoc: "recipient",
    ocitanaTemperatura: "Read temperature",
    dozvoljenaTempMin: "Allowed minimum temperature",
    dozvoljenaTempMax: "Allowed maximum temperature",
    dozvoljenoOdstupanje: "Allowed deviation",
    stanje: "Insect infestation",
    opisMjeereKorekcije: "Correction measure description",
    ocitanaTemperaturaKorekcije: "Read correction temperature",
    dozvoljenaTempMinKorekcije: "Allowed min. correction temperature",
    dozvoljenaTempMaxKorekcije: "Allowed max. correction temperature",
    imePrezimeKorekcije: "First and last name of correction performer",
    potpisIzvrsiocaKorekcije: "Correction performer signature",
    datumKorekcije: "Correction date",
    vrijemeKorekcije: "Correction time",
    zadovoljenaKontrola: "Allowed temperature",
    napomena: "Note",
    upisaoFooter: "Controlled/Approved by",
    potpisFooter: "Signature",
    kontrolisaoPrimioRadove: "Controlled/received work",
  },
};

export interface ListaEvidencijaResourcesBSInterface {
  title: string;
  listaTacakaEvidencije: string;
  listaEvidencija: string;
  errorLoading: string;
  branchButton: string;
  next: string;
  back: string;
  from: string;
  to: string;
  description: string;
  selectDateRange: string;
  loadingBranches: string;
  loadingEvidenceRecords: string;
  loadingEvidenceList: string;
  clickToViewDetails: string;
  branch: {
    label: string;
    placeholder: string;
    notFound: string;
  };
  evidencije: {
    title: string;
    pojedinacneDownload: string;
    zbirniDownload: string;
    edit: string;
  };
  pdf: {
    right: {
      title: string;
      from: string;
      to: string;
    };
    center: {
      title: string;
    };
  };
  poljaEvidencije: {
    CIPP_V1: string;
    CIPO_V1: string;
    Dezinfekcija_V1: string;
    Dezinsekcija_V1: string;
    Deratizacija_V1: string;
    Dezinsekcija_Kontrola_V1: string;
    Dezinskecija_Korekcija_V1: string;
    Deratizacija_Kontrole_V1: string;
    Deratizacija_Korekcije_V1: string;
    DezSr_V1: string;
    Dobavljac_V1: string;
    Dostava_V1: string;
    EduZap_V1: string;
    Mol_V1: string;
    Oprema_V1: string;
    Otpad_V1: string;
    PrijemRobe_V1: string;
    San_V1: string;
    Temperatura_V1: string;
    TemperaturaOgranicena_V1: string;
    TemperaturaOgranicenaKKT_V1: string;
    TemperaturaKKTProizvodiEvd_V1: string;
  };
  pdfListaEvidencija: ITextFields;
  sanEvdsList: {
    found: string;
    notFound: string;
    download: string;
    button: string;
  };
}
